import { MutationTree } from 'vuex';
import { DeviceInfo } from '@/common/apis/DeviceApi';
import { ViewsState } from './types';
import Vue from 'vue';

export const mutations: MutationTree<ViewsState> = {
    loaded(state, args: {deviceNumber: string, views: {[key: string]: any}}) {
        Vue.set(state.views, args.deviceNumber, args.views);
        // state.views[args.deviceNumber] = args.views;
    },
    updateView(state, args: {deviceNumber: string, key: string, payload: any}) {
        const views = state.views[args.deviceNumber];
        if (!views) {
            throw { message: 'Could not find device in views', args};
        }
        Vue.set(views, args.key, args.payload);
    },
    clear(state) {
        state.views = {};
    },
};
